import { VoiceResponseCommand } from '../../../objects/voice-response-command/generic/voice-response-command';
import { SetContext } from '../../../objects/voice-response-command/set-context/set-context';

import { GetAllLanguagesInput } from './interfaces';

export const getAllLanguages = (params: GetAllLanguagesInput): string[] => {
  const { ivrs, callEntrypoints, callLists, serviceExceptions } = params;
  const languages = new Set<string>();

  const collectLanguagesFromCommands = (commands: VoiceResponseCommand[] = []) => {
    for (const command of commands) {
      if (command instanceof SetContext) {
        languages.add(command.getLanguage());
      }
    }
  };

  for (const ivr of ivrs) {
    collectLanguagesFromCommands(ivr.getMenuOptionsCommands());
    collectLanguagesFromCommands(ivr.getInvalidKeyPressedCommands());
    collectLanguagesFromCommands(ivr.getOnFailure());
    for (const option of ivr.getOptions()) {
      collectLanguagesFromCommands(option.getCommands());
    }
  }

  for (const callEntrypoint of callEntrypoints) {
    collectLanguagesFromCommands(callEntrypoint.getCommands());
  }

  for (const callList of callLists) {
    collectLanguagesFromCommands(callList.getOnNoUserLeftToDialModIncCallCommands());
    collectLanguagesFromCommands(callList.getCallerHangupOnStarCommands());
    collectLanguagesFromCommands(callList.getCalleeHangupOnStarCommands());
  }

  for (const serviceException of serviceExceptions) {
    const inboundCallSessionAction = serviceException.getInboundCallSessionAction();
    const onCreate = inboundCallSessionAction?.getOnCreate();
    collectLanguagesFromCommands(onCreate?.getCommands());
  }

  return Array.from(languages).sort();
};
